module.exports = __webpack_public_path__ + "static/img/autoever-ecampus.f1454df.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/autoever-ecampus.jpg
// module id = ODtv
// module chunks = 0